import React, { useEffect, useState } from "react"
import { usePet, useSocketEvents } from "../../modules"

const QueueEntry = ({ entry, order, children }) => {
    const [called, setCalled] = useState()
    const [enaged, setEngaged] = useState()

    const [{ loading, error }, callPatient] = usePet('callForPatient', { id: entry?.ref?._id ?? order, type: entry?.ref?._id ? 'item' : 'order', station: localStorage.getItem('station') }, { notify: true, callback: ({ data }, notif, ops) => notif('Call has been sent, please wait for patient', ops('success')), manual: true, load: { msg: 'Sending call...' } })

    useSocketEvents({
        'audio-queue-update': {
            callback: data => {
                let { patient, station } = data
    
                if (patient === entry?.ref?.patient?._id && station !== localStorage.getItem('station')) {
                    setCalled(station)
                    setTimeout(() => setCalled(), 60000)
                }
            }
        },
        
        'currently-engaging': {
            callback: data => {
                let [patient, station] = data

                if (patient === entry?.ref?.patient?._id && station !== localStorage.getItem('station')) {
                    setEngaged(station)
                    setTimeout(() => setEngaged(), 60000)
                }
            }
        }
    })

    return children(called, enaged, callPatient, loading, error)
}

export default QueueEntry